(function () {
  "use strict";

  var DEFAULT_WEIGHTS = {
    note: 3,
    scent: 3,
    mood: 2,
    vibe: 2,
    feel: 3,
    habit: 1,
    age: 1,
  };

  var SCENT_FAMILY_MAP = {
    fresh: ["fresh", "citrusy", "aquatic"],
    warm: ["woody", "spicy"],
    sweet: ["fruity", "floral"],
    strong: ["spicy", "woody"],
    light: ["citrusy", "fresh"],
    powdery: ["floral"],
  };

  var REVEAL_LABELS = [
    "Reveal fragrance families",
    "Reveal note matches",
    "Reveal fragrance matches",
  ];

  var GENERIC_ARCHETYPE = {
    name: "Your Signature Scent",
    tagline: "Distinct, personal & unmistakably you",
    text: "Based on your answers, we've drawn together a profile that's all your own — a balance of the notes, moods and character you leaned toward.",
  };

  var ANALYZE_MESSAGES = [
    "Reading your scent profile…",
    "Mapping olfactive families…",
    "Pulling matches from the atelier…",
  ];

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function initQuiz(root) {
    if (!root || root.dataset.frgqInit === "true") return;
    root.dataset.frgqInit = "true";

    var data = readJSON("frgq-data") || {};
    var products = readJSON("frgq-products") || [];
    var notesDict = data.notes || {};
    var analyzeMs = Math.max(1500, parseInt(data.analyzeMs, 10) || 2600);
    var maxResults = Math.max(1, parseInt(data.maxResults, 10) || 6);

    var cfg = readJSON("frgq-config") || {};
    var weights = {};
    var wKeys = ["note", "scent", "mood", "vibe", "feel", "habit", "age"];
    wKeys.forEach(function (k) {
      var v = cfg.weights && cfg.weights[k];
      weights[k] = typeof v === "number" ? v : DEFAULT_WEIGHTS[k];
    });
    var moodMap = cfg.moods || {};
    var vibeMap = cfg.vibes || {};
    var habitMap = cfg.habits || {};
    var ageMap = cfg.ages || {};
    var feelMap = cfg.feels || {};
    var archetypes = cfg.archetypes || {};
    var showMatchBadge = !!cfg.showMatchBadge;

    var steps = Array.prototype.slice.call(
      root.querySelectorAll("[data-frgq-step]"),
    );
    var progressFill = root.querySelector("[data-frgq-progress]");
    var counter = root.querySelector("[data-frgq-counter]");
    var backBtn = root.querySelector("[data-frgq-back]");
    var analyzing = root.querySelector("[data-frgq-analyzing]");
    var analyzingFill = root.querySelector("[data-frgq-analyzing-bar]");
    var analyzingPct = root.querySelector("[data-frgq-analyzing-pct]");
    var analyzingMsg = root.querySelector("[data-frgq-analyzing-msg]");
    var results = root.querySelector("[data-frgq-results]");
    var header = root.querySelector("[data-frgq-header]");

    var answers = {
      gender: null,
      unisex: null,
      notes: [],
      scents: [],
      mood: null,
      vibe: null,
      habit: null,
      age: null,
      feel: null,
    };

    var current = 0;

    function stepIsSkipped(step) {
      return step.dataset.frgqStep === "unisex" && answers.gender === "unisex";
    }

    function activeSteps() {
      return steps.filter(function (s) {
        return !stepIsSkipped(s);
      });
    }

    function showStep(index) {
      var act = activeSteps();
      if (index < 0) index = 0;
      if (index >= act.length) return;
      current = index;

      steps.forEach(function (s) {
        s.classList.remove("frgq-step--active");
      });
      act[index].classList.add("frgq-step--active");

      if (counter) counter.textContent = index + 1 + " of " + act.length;
      if (progressFill) {
        progressFill.style.width = ((index + 1) / act.length) * 100 + "%";
      }
      if (backBtn)
        backBtn.style.visibility = index === 0 ? "hidden" : "visible";

      root.scrollIntoView({
        behavior: prefersReducedMotion() ? "auto" : "smooth",
        block: "start",
      });
      syncStepUI(act[index]);
    }

    function next() {
      var act = activeSteps();
      if (current + 1 >= act.length) {
        startAnalyzing();
      } else {
        showStep(current + 1);
      }
    }

    function syncStepUI(step) {
      var key = step.dataset.frgqStep;
      var multi = step.dataset.frgqMulti === "true";
      var maxAttr = step.dataset.frgqMax;
      var continueBtn = step.querySelector("[data-frgq-continue]");
      if (!continueBtn) return;
      var count = Array.isArray(answers[key]) ? answers[key].length : 0;
      continueBtn.disabled = count === 0;
      if (multi) {
        var label = step.querySelector("[data-frgq-count]");
        if (label) {
          label.textContent = maxAttr
            ? count + " / " + maxAttr
            : count + " selected";
        }
      }
    }

    steps.forEach(function (step) {
      var key = step.dataset.frgqStep;
      var multi = step.dataset.frgqMulti === "true";

      var max = step.dataset.frgqMax
        ? parseInt(step.dataset.frgqMax, 10)
        : Infinity;
      var options = step.querySelectorAll("[data-frgq-option]");

      options.forEach(function (opt) {
        opt.addEventListener("click", function () {
          var value = opt.dataset.frgqOption;

          if (multi) {
            var list = answers[key];
            var at = list.indexOf(value);
            if (at >= 0) {
              list.splice(at, 1);
              opt.classList.remove("frgq-option--selected");
            } else {
              if (list.length >= max) return;
              list.push(value);
              opt.classList.add("frgq-option--selected");
            }
            syncStepUI(step);
          } else {
            answers[key] = value;
            options.forEach(function (o) {
              o.classList.remove("frgq-option--selected");
            });
            opt.classList.add("frgq-option--selected");

            window.setTimeout(next, prefersReducedMotion() ? 0 : 260);
          }
        });
      });

      var continueBtn = step.querySelector("[data-frgq-continue]");
      if (continueBtn) {
        continueBtn.addEventListener("click", next);
      }
      var skipBtn = step.querySelector("[data-frgq-skip]");
      if (skipBtn) {
        skipBtn.addEventListener("click", function () {
          if (Array.isArray(answers[key])) answers[key] = [];
          else answers[key] = null;
          step.querySelectorAll(".frgq-option--selected").forEach(function (o) {
            o.classList.remove("frgq-option--selected");
          });
          next();
        });
      }
    });

    Array.prototype.forEach.call(
      root.querySelectorAll("[data-frgq-filter]"),
      function (input) {
        var step = input.closest("[data-frgq-step]");
        if (!step) return;
        var list = step.querySelector("[data-frgq-filter-list]");
        if (!list) return;
        var empty = step.querySelector("[data-frgq-filter-empty]");
        var optionEls = Array.prototype.slice.call(
          list.querySelectorAll("[data-frgq-option]"),
        );

        input.addEventListener("input", function () {
          var q = input.value.trim().toLowerCase();
          var visible = 0;
          optionEls.forEach(function (opt) {
            var label =
              opt.dataset.frgqLabel || opt.textContent.trim().toLowerCase();
            var match = !q || label.indexOf(q) >= 0;
            opt.hidden = !match;
            if (match) visible++;
          });
          if (empty) empty.hidden = visible > 0;
        });
      },
    );

    if (backBtn) {
      backBtn.addEventListener("click", function () {
        showStep(current - 1);
      });
    }

    function startAnalyzing() {
      if (header) header.style.display = "none";
      steps.forEach(function (s) {
        s.classList.remove("frgq-step--active");
      });
      if (!analyzing) return showResults();
      analyzing.classList.add("frgq-analyzing--active");

      var start = Date.now();
      var msgIndex = 0;
      if (analyzingMsg) analyzingMsg.textContent = ANALYZE_MESSAGES[0];

      var tick = window.setInterval(function () {
        var t = Math.min(1, (Date.now() - start) / analyzeMs);

        var pct = Math.round(100 * (1 - Math.pow(1 - t, 2)));
        if (analyzingFill) analyzingFill.style.width = pct + "%";
        if (analyzingPct) analyzingPct.textContent = pct + "%";

        var nextMsg = Math.min(
          ANALYZE_MESSAGES.length - 1,
          Math.floor(t * ANALYZE_MESSAGES.length),
        );
        if (nextMsg !== msgIndex && analyzingMsg) {
          msgIndex = nextMsg;
          analyzingMsg.textContent = ANALYZE_MESSAGES[msgIndex];
        }

        if (t >= 1) {
          window.clearInterval(tick);
          window.setTimeout(function () {
            analyzing.classList.remove("frgq-analyzing--active");
            showResults();
          }, 250);
        }
      }, 50);
    }

    function intersect(a, b) {
      var n = 0;
      for (var i = 0; i < a.length; i++) {
        if (b.indexOf(a[i]) >= 0) n++;
      }
      return n;
    }

    function allowedGenders() {
      if (!answers.gender || answers.gender === "unisex") return null;
      var allowed = [answers.gender];
      if (answers.unisex !== "no") allowed.push("unisex");
      return allowed;
    }

    function scoreProduct(p) {
      var score = 0;
      score += weights.note * intersect(answers.notes, p.notes);
      score += weights.scent * intersect(answers.scents, p.scents);

      var mood = moodMap[answers.mood];
      if (mood) {
        score +=
          weights.mood * intersect(mood.personalities || [], p.personalities);
        score += weights.mood * intersect(mood.families || [], p.families);
      }

      var vibe = vibeMap[answers.vibe];
      if (vibe) {
        score += weights.vibe * intersect(vibe.scents || [], p.scents);
        score += weights.vibe * intersect(vibe.families || [], p.families);
      }

      var feel = feelMap[answers.feel];
      if (feel) {
        score +=
          weights.feel * intersect(feel.personalities || [], p.personalities);
        score += weights.feel * intersect(feel.families || [], p.families);
      }

      var habit = habitMap[answers.habit];
      if (habit) {
        score += weights.habit * intersect(habit.badges || [], p.badges);
        score += weights.habit * intersect(habit.families || [], p.families);
      }

      var age = ageMap[answers.age];
      if (age) {
        score += weights.age * intersect(age.scents || [], p.scents);
        score += weights.age * intersect(age.families || [], p.families);
        score +=
          weights.age * intersect(age.personalities || [], p.personalities);
      }

      return score;
    }

    function computeMatches() {
      var allowed = allowedGenders();

      var pool = products.filter(function (p) {
        if (!allowed) return true;
        if (!p.genders.length) return true;
        return intersect(allowed, p.genders) > 0;
      });

      if (pool.length < 3) pool = products.slice();

      var scored = pool
        .map(function (p) {
          return { product: p, score: scoreProduct(p) };
        })
        .sort(function (a, b) {
          return b.score - a.score;
        });

      var top = scored.slice(0, maxResults);
      var maxScore = top.length && top[0].score > 0 ? top[0].score : 1;
      top.forEach(function (m, i) {
        var pct = Math.round(70 + 28 * (m.score / maxScore)) - i;
        m.pct = Math.max(62, pct);
      });
      return top;
    }

    function computeFamilies(matches) {
      var tally = {};
      function add(handle, weight) {
        tally[handle] = (tally[handle] || 0) + weight;
      }

      var prodTally = {};
      var prodTop = 1;
      matches.forEach(function (m) {
        var weight = Math.max(1, m.score);
        m.product.families.forEach(function (f) {
          prodTally[f] = (prodTally[f] || 0) + weight;
          if (prodTally[f] > prodTop) prodTop = prodTally[f];
        });
      });
      Object.keys(prodTally).forEach(function (f) {
        add(f, 10 * (prodTally[f] / prodTop));
      });

      answers.scents.forEach(function (s) {
        (SCENT_FAMILY_MAP[s] || []).forEach(function (f) {
          add(f, 6);
        });
      });
      var mood = moodMap[answers.mood];
      if (mood && mood.families) {
        mood.families.forEach(function (f) {
          add(f, 5);
        });
      }
      var vibe = vibeMap[answers.vibe];
      if (vibe && vibe.families) {
        vibe.families.forEach(function (f) {
          add(f, 4);
        });
      }

      var entries = Object.keys(tally)
        .map(function (f) {
          return { handle: f, value: tally[f] };
        })
        .sort(function (a, b) {
          return b.value - a.value;
        })
        .slice(0, 4);

      var sum = entries.reduce(function (acc, e) {
        return acc + e.value;
      }, 0);
      if (sum <= 0) sum = 1;
      entries.forEach(function (e) {
        e.pct = Math.max(4, Math.round(100 * (e.value / sum)));
      });
      return entries;
    }

    function computeNotes(matches) {
      var chosen = answers.notes.slice();
      var tally = {};
      matches.forEach(function (m) {
        m.product.notes.forEach(function (n) {
          if (chosen.indexOf(n) >= 0) return;
          tally[n] = (tally[n] || 0) + 1;
        });
      });
      var extra = Object.keys(tally)
        .sort(function (a, b) {
          return tally[b] - tally[a];
        })
        .slice(0, Math.max(0, 6 - chosen.length));
      return chosen.concat(extra);
    }

    function el(tag, className, html) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (html != null) node.innerHTML = html;
      return node;
    }

    function titleize(handle) {
      return handle
        .split("-")
        .map(function (w) {
          return w.charAt(0).toUpperCase() + w.slice(1);
        })
        .join(" ");
    }

    function escapeHtml(s) {
      var div = document.createElement("div");
      div.textContent = s == null ? "" : String(s);
      return div.innerHTML;
    }

    function showResults() {
      if (!results) return;
      var matches = computeMatches();
      var families = computeFamilies(matches);
      var noteHandles = computeNotes(matches);
      var archetype = archetypes[answers.feel] || GENERIC_ARCHETYPE;
      var pool = root.querySelector("[data-frgq-pool]");

      results.innerHTML = "";
      results.classList.add("frgq-results--active");

      var stages = [renderProfile, renderFamilies, renderNotes, renderMatches];
      var stageIndex = -1;

      function nextStage() {
        stageIndex++;
        results.innerHTML = "";
        var block = stages[stageIndex]();
        results.appendChild(block);

        window.setTimeout(function () {
          block.scrollIntoView({
            behavior: prefersReducedMotion() ? "auto" : "smooth",
            block: stageIndex === stages.length - 1 ? "start" : "center",
          });
        }, 80);
      }

      function stagePanel(stepNumber) {
        var panel = el("div", "frgq-stage");
        panel.appendChild(
          el("span", "frgq-stage__step", stepNumber + " of " + stages.length),
        );
        return panel;
      }

      function revealBtn(label) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "frgq-btn frgq-btn--gold frgq-stage__btn";
        btn.innerHTML =
          escapeHtml(label) + ' <span aria-hidden="true">&#8250;</span>';
        btn.addEventListener("click", nextStage);
        return btn;
      }

      function renderProfile() {
        var panel = stagePanel(1);
        panel.appendChild(el("p", "frgq-eyebrow", "Your Scent Profile"));
        panel.appendChild(
          el("h2", "frgq-profile__name", escapeHtml(archetype.name)),
        );
        panel.appendChild(
          el("p", "frgq-profile__tagline", escapeHtml(archetype.tagline)),
        );
        panel.appendChild(
          el("p", "frgq-profile__text", escapeHtml(archetype.text)),
        );
        if (answers.gender) {
          var chips = el("div", "frgq-profile__chips");
          chips.appendChild(
            el("span", "frgq-chip", escapeHtml(titleize(answers.gender))),
          );
          panel.appendChild(chips);
        }
        panel.appendChild(revealBtn(REVEAL_LABELS[0]));
        return panel;
      }

      function renderFamilies() {
        var panel = stagePanel(2);
        panel.appendChild(el("p", "frgq-eyebrow", "Your Fragrance Families"));

        if (families.length) {
          panel.appendChild(
            el(
              "h3",
              "frgq-result__heading",
              "You lean most toward <em>" +
                escapeHtml(titleize(families[0].handle)) +
                "</em>",
            ),
          );

          var topValue = families[0].value || 1;
          var bars = el("div", "frgq-families__bars");
          families.forEach(function (f) {
            var row = el("div", "frgq-families__row");
            row.appendChild(
              el(
                "span",
                "frgq-families__label",
                escapeHtml(titleize(f.handle)),
              ),
            );
            var track = el("div", "frgq-families__track");
            var fill = el("div", "frgq-families__fill");
            fill.style.width = "0%";
            track.appendChild(fill);
            row.appendChild(track);
            row.appendChild(el("span", "frgq-families__pct", f.pct + "%"));
            bars.appendChild(row);

            var barWidth = Math.max(8, Math.round(100 * (f.value / topValue)));
            window.setTimeout(function () {
              fill.style.width = barWidth + "%";
            }, 350);
          });
          panel.appendChild(bars);
        } else {
          panel.appendChild(
            el(
              "h3",
              "frgq-result__heading",
              "Your profile spans <em>every family</em>",
            ),
          );
        }

        panel.appendChild(revealBtn(REVEAL_LABELS[1]));
        return panel;
      }

      function renderNotes() {
        var panel = stagePanel(3);
        panel.appendChild(el("p", "frgq-eyebrow", "Notes You'll Love"));
        panel.appendChild(
          el("h3", "frgq-result__heading", "The accords behind your matches"),
        );
        var grid = el("div", "frgq-notes-result__grid");
        noteHandles.forEach(function (h) {
          var info = notesDict[h] || { name: titleize(h), image: "" };
          var item = el("div", "frgq-note");
          var imgWrap = el("span", "frgq-note__img");
          if (info.image) {
            var img = document.createElement("img");
            img.src = info.image;
            img.alt = info.name;
            img.loading = "lazy";
            img.width = 88;
            img.height = 88;
            imgWrap.appendChild(img);
          }
          item.appendChild(imgWrap);
          item.appendChild(
            el("span", "frgq-note__name", escapeHtml(info.name)),
          );
          grid.appendChild(item);
        });
        panel.appendChild(grid);
        panel.appendChild(revealBtn(REVEAL_LABELS[2]));
        return panel;
      }

      function renderMatches() {
        var prodBlock = el("div", "frgq-result frgq-matches");
        prodBlock.appendChild(el("p", "frgq-eyebrow", "Your Maceoo Edit"));
        prodBlock.appendChild(
          el(
            "h3",
            "frgq-result__heading",
            "The parfums selected for <em>your profile</em>",
          ),
        );

        var cards = el("div", "frgq-matches__grid");
        matches.forEach(function (m) {
          var node =
            pool &&
            pool.querySelector('[data-frgq-card="' + m.product.handle + '"]');
          if (!node) return;
          var pctEl = node.querySelector("[data-frgq-pct]");
          if (pctEl) {
            if (showMatchBadge) {
              pctEl.textContent = m.pct + "% match";
              pctEl.hidden = false;
            } else {
              pctEl.textContent = "";
              pctEl.hidden = true;
            }
          }
          node.hidden = false;
          cards.appendChild(node);
        });
        prodBlock.appendChild(cards);

        var actions = el("div", "frgq-actions");
        var retake = el(
          "button",
          "frgq-btn frgq-btn--ghost",
          "Retake the quiz",
        );
        retake.type = "button";
        retake.addEventListener("click", function () {
          window.location.reload();
        });
        actions.appendChild(retake);
        if (data.collectionUrl) {
          var browse = el(
            "a",
            "frgq-btn frgq-btn--gold",
            "Browse all fragrances",
          );
          browse.href = data.collectionUrl;
          actions.appendChild(browse);
        }
        prodBlock.appendChild(actions);
        return prodBlock;
      }

      nextStage();
    }

    showStep(0);
  }

  function initAll(container) {
    Array.prototype.forEach.call(
      container.querySelectorAll("[data-frgq]"),
      initQuiz,
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target || document);
  });
})();
